import type { AnatomyBinding, AnatomyVariant } from "./componentAnatomy";

const border = (token: `--${string}`): AnatomyBinding => ({
    partId: "border",
    property: "border-color",
    token,
    via: "--textarea-border",
});
const grip = (token: `--${string}`): AnatomyBinding => ({
    partId: "grip",
    property: "color",
    token,
    via: "--textarea-grip-color",
});
const text = (token: `--${string}`): AnatomyBinding => ({
    partId: "label",
    property: "color",
    token,
    via: "--textarea-fg",
});
const placeholder = (token: `--${string}`): AnatomyBinding => ({
    partId: "label",
    property: "color (placeholder)",
    token,
    via: "--textarea-placeholder",
});
const background = (token: `--${string}`): AnatomyBinding => ({
    partId: "background",
    property: "background-color",
    token,
    via: "--textarea-bg",
});

const ringBindings: readonly AnatomyBinding[] = [
    {
        partId: "focusRing",
        property: "box-shadow (spread)",
        token: "--border-width-thick",
    },
    {
        partId: "focusRing",
        property: "box-shadow (color)",
        token: "--focus-ring-color",
    },
];

const focusBindings: readonly AnatomyBinding[] = [
    border("--border-accent-focus"),
    ...ringBindings,
];

const primaryRestingBindings: readonly AnatomyBinding[] = [
    background("--bg-primary"),
    text("--fg-primary"),
    placeholder("--fg-tertiary"),
    border("--border-default"),
];

const primaryReadOnlyBindings: readonly AnatomyBinding[] = [
    background("--bg-primary"),
    text("--fg-tertiary"),
    placeholder("--fg-tertiary"),
    border("--border-disabled"),
];

const disabledBorder: AnatomyBinding = {
    partId: "border",
    property: "border-color",
    token: "--border-disabled",
    via: "--textarea-border",
    note: "Figma keeps Border/default; raised as T1 in PRO-12023",
};

export const textAreaVariantSpecs: readonly AnatomyVariant[] = [
    {
        id: "primary",
        label: "Primary",
        selector: ".primary",
        restingBindings: primaryRestingBindings,
        stateBindings: {
            hover: [border("--border-hover"), grip("--border-hover")],
            focus: focusBindings,
            readOnly: primaryReadOnlyBindings,
            disabled: [
                text("--fg-disabled"),
                placeholder("--fg-disabled"),
                disabledBorder,
            ],
        },
    },
    {
        id: "primary-invalid",
        label: "Primary · invalid",
        selector:
            '.primary:has(.control[aria-invalid="true"]):not(:has(.control:disabled)):not([data-disabled]):not(:has(.control:focus)):not([data-forced-state="focus"])',
        restingBindings: [
            background("--bg-primary"),
            text("--fg-error"),
            placeholder("--fg-error-placeholder"),
            border("--border-error"),
            grip("--border-error"),
        ],
        stateBindings: {
            hover: [
                border("--border-error-hover"),
                grip("--border-error-hover"),
            ],
            focus: [
                ...primaryRestingBindings,
                grip("--border-default"),
                ...focusBindings,
            ],
            readOnly: primaryReadOnlyBindings,
        },
    },
];
